import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { filter, startWith, takeUntil } from 'rxjs/operators';

import { AnalyticsService } from '@digital-platform/rs-analytics/services';
import { ENVIRONMENT } from '@digital-platform/rs-shared/services';

@Component({
  selector: 'digital-platform-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, OnDestroy {
  public isBrowser = true;
  private document = inject(DOCUMENT);
  private environment = inject(ENVIRONMENT);
  private destroyed$ = new Subject<void>();
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private cookieService = inject(CookieService);
  private analyticsService = inject(AnalyticsService);

  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        filter((event: any) => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe((value) => {
        // Only register page analytics for non JS pages
        if (value.url) {
          const regex = /[?;]/g;
          const splitUrl = value.url.split(regex);

          let rootUrl = splitUrl[0];

          rootUrl = rootUrl === '/home' ? '/' : rootUrl;

          this.analyticsService.registerPageName(rootUrl);
        }
      });

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroyed$))
      .subscribe((params) => {
        const googleClickId = params['gclid'];

        // Get gclid from query params and store it as cookie
        if (googleClickId) {
          this.cookieService.set('gclid', googleClickId.toString(), 30);
        }
      });

    // Only run Medallia if this is a client-side rendered page.
    if (this.isBrowser) {
      this.enableMedallia();
    }
  }

  private enableMedallia(): void {
    if (this.environment.production) {
      this.document.cookie = 'medallia.enabled=true';
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
